import { useRef } from 'react';
import './Checkbox.css';

interface CheckboxProps {
  name?: string;
  value: boolean;
  onChange: (val: boolean) => void;
  disabled?: boolean;
}

export default function Checkbox({
  name,
  value,
  onChange,
  disabled = false
}: CheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = () => {
    if (inputRef.current) {
      onChange(!inputRef.current.checked);
    }
  };

  return (
    <div className="Checkbox">
      <input
        ref={inputRef}
        id={name}
        name={name}
        checked={value}
        type="checkbox"
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)} // The field is not visible so this should not be used, unless the CSS is deactivated
      />
      <button
        className={`Checkbox-check${disabled ? ' is-disabled' : ''}`}
        onClick={handleChange}
      />
    </div>
  );
}
